import React, { useEffect, useState } from 'react'
import { Box, Button, Container, FormControl, Grid, InputLabel, NativeSelect, Typography, } from '@mui/material';
import TextField from '@mui/material/TextField';
import Nftstats from './Nftstats';
import Nftproperty from './Nftproperty';
import Nftlevel from './Nftlevel';
import Selectform from './Selectform';
import Collectionselect from './Collectionselect';
import { useCheckChain } from '../../Hooks/useCheckChain';
import { API_URL, Bsc_Chainid, ETH_Chainid, Matic_Chainid } from '../../Config';
import { useWeb3React } from '@web3-react/core';
import axios from 'axios';
import { Label } from 'semantic-ui-react';

const label = { inputProps: { 'aria-label': 'Size switch demo' } };
const Formcreate = (props) => { 
    const { setState } = props
    const {setProperty} = props
    const {setlevel} =props
    const {state}=props
    const {property} =props
    const {level} =props
    const {account} =useWeb3React();
    const [royalty, setroyalty] = useState("");
    const [disabled, setdisable] = useState(false);
    const { switchChain } = useCheckChain();
    const [changedcurrency, setchangedcurrency] = useState("BNB");
    const [Tokendata,SetTokendata]=useState("");

    function changeroyalty(e) {
     
        setroyalty(e.target.value);
        if (royalty > 50) {
            setdisable(true);
        } else {
            setdisable(false);
        }
    }
    
    function changecurrency(e) {
        let currency = e.target.value;
        setchangedcurrency(currency);
        if (currency == "BNB") {
            switchChain(Bsc_Chainid);
        } else if (currency == "MATIC") {
            switchChain(Matic_Chainid);
        } else if(currency == "ETH"){
            switchChain(ETH_Chainid);
        }
    }

    const TokenData =async()=>{
       
        var data =new FormData();
        data.append("useraddress",account)
        data.append("type","SelectToken");
        data.append("currency",changedcurrency)

        await axios
        .post(`${API_URL}/TokenApi.php`, data ,{
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then(async (req) => {
        
            if (req.data) {
                SetTokendata(req.data);
            }
        })
    }

    useEffect(()=>{
        TokenData()
    },[changedcurrency,account])
    return (
        <div>
            <Box className='form_start'>
                <Container maxWidth='xl'>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} xs={12}>
                            <Box>
                            <Label className='lab_dec'>Enter NFT name</Label>
                                <TextField className='out_len' fullWidth id="outlined-basic" placeholder='Item name' variant="outlined" name='title'/>
                                <Label className='lab_dec'>Description of your nft in detail</Label>
                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>The description will be included on the item's detail page underneath its image. Markdown syntax is supported.</Typography>
                                <TextField className='out_len' fullWidth id="outlined-basic"  placeholder='Provide a detailed description of your item.' variant="outlined" name='discription'/>
                                <Label className='lab_dec'>Royality</Label>
                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Earn a percentage of the sale price every time one of your items is sold.</Typography>
                               
                                <TextField className='out_len' fullWidth id="filled-number" inputProps={{
                                    min:0,
                                    step:'any'
                                }}  type='number' variant="outlined" defaultValue="0" name='royalty' onChange={changeroyalty}/>
                                <h5 style={{ color: "red" }}>
                                    {royalty > 50 && "Enter the royalty less than 50%"}
                                </h5>

                                <Label className='lab_dec'>Product Price</Label>
                            <TextField className='out_len' fullWidth id="outlined-basic" type='number' variant="outlined" 
                            inputProps={{
                                    min:0,
                                    step:'any'
                                }} name="price" />
                            </Box>
                        </Grid>
                       
                        <Grid item lg={6} sm={6} xs={12}>
                        <Label className='lab_dec'>Number of Tokens</Label>
                            <TextField className='out_len' fullWidth id="outlined-basic" type='number' variant="outlined" 
                            inputProps={{
                                    min:0,
                                    step:'any'
                                }} name="token" />
                        </Grid>
                        <Grid item lg={3} sm={3} xs={6}>
                        <Label className='lab_dec'>Select Currency</Label>
                            <FormControl fullWidth>
                                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                                </InputLabel>
                                <NativeSelect defaultValue="BNB" name="currency" onChange={changecurrency}>
                                    <option value="BNB">BNB</option>
                                    <option value="MATIC">MATIC</option>
                                    <option value="ETH">ETH</option>
                                </NativeSelect>
                            </FormControl>
                        </Grid>
                        <Grid item lg={3} sm={3} xs={6}>
                        <Label className='lab_dec'>Select Token</Label>
                            <FormControl fullWidth>
                                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                                </InputLabel>
                                <NativeSelect defaultValue="" name="TokenName" >
                                    <option  value="" >SELECT</option>
                                    {Tokendata.length>0 && Tokendata.map((token,idx)=>(

                                        <option key={idx} value={token.Tokenaddress} >{token.TokenName}</option>
                                    ))}
                                 
                                </NativeSelect>
                            </FormControl>
                        </Grid>

                        <Grid item lg={12} sm={12} xs={12}>
                            <Box >
                                <Typography variant='h4' color='#000' fontSize='17px' fontWeight='500'>  NFT’s Stats </Typography>
                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Numerical traits that just show as numbers</Typography>
                               
                                <Nftstats setState={setState}/>
                            </Box>
                            <Grid container spacing={2} marginY='5px'>
                                {state && state.map((state,index)=>(
                                    <Grid key={index} item lg={3} sm={12} xs={12}>
                                    <Box className='trait'>
                                        <Typography variant='h6' fontSize='16px' fontWeight='300'> {state.name} </Typography>
                                        <Typography variant='h3' fontSize='20px' fontWeight='600'> {state.value}/5</Typography>
                                        
                                    </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item lg={12} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h4' color='#000' fontSize='17px' fontWeight='500'>  NFT’s Properties </Typography>
                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Textual traits that show up as rectangles</Typography>
                                <Nftproperty  setProperty={setProperty} />
                            </Box>
                            <Grid container spacing={2} marginY='5px'>
                            {property && property.map((prop,idx)=>(
                                <Grid key={idx} item lg={3} sm={12} xs={12}>
                                    <Box className='trait'>
                                        <Typography variant='h6' fontSize='16px' fontWeight='300'> {prop.type}</Typography>
                                        <Typography variant='h3' fontSize='20px' fontWeight='600'> {prop.propname}</Typography>
                                    </Box>
                                </Grid>
                                ))}
                         
                            </Grid>
                        </Grid>
                        <Grid item lg={12} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h4' color='#000' fontSize='17px' fontWeight='500'> NFT’s Levels </Typography>
                                <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>Numerical traits that show as a progress bar</Typography>
                             <Nftlevel  setlevel={setlevel}/>
                            </Box>
                        <Grid container spacing={2} marginY='5px'>
                            {level && level.map((level,index)=>(
                                    <Grid key={index} item lg={3} sm={12} xs={12}>
                                    <Box className='trait'>
                                        <Typography variant='h6' fontSize='16px' fontWeight='300'> {level.name} </Typography>
                                        <Typography variant='h3' fontSize='20px' fontWeight='600'> {level.value} </Typography>
                                        <Typography variant='h5' fontSize='18px' fontWeight='400'>5</Typography>
                                    </Box>
                                    </Grid>
                                ))}
                            </Grid> 
                        </Grid>
                        <Grid item lg={12} sm={12} xs={12}>
                            <Selectform />
                        </Grid>
                        <Grid item lg={12} sm={12} xs={12}>
                            <Collectionselect />
                        </Grid>
                        <Grid item lg={12} sm={12} xs={12}>
                            <Button variant="contained" className='item_sub' type="submit">Create NFT</Button>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </div>
    )
}

export default Formcreate; 